import { createContext } from 'react';

export const SearchBtnContext = createContext([true, {} as any]); //検索ボタンが押せる
export const MenuContext = createContext([false, {} as any]); //管理者メニューが開く
